import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/ourClientsSay/style.scss";

const OurClientSayComponent = ({ ref }) => {
  const [selectedFooter, setSelectedFooter] = useState(1);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (prev, next) => {
      setSelectedFooter([0, 1, 2].includes(next) ? 1 : 2);
    },
  };

  return (
    <div className="our-clients-say-wrapper" ref={ref}>
      <div className="our-clients-say-heading">What Our Clients Say</div>
      <div className="our-clients-say-sub-heading">
        Don't just take our word for it. Hear from the businesses we've helped.
      </div>

      {/* desktopResponsvie */}
      <div className="our-client-say-card-wrapper desktop-view-our-client-say-card">
        <div className="oppacity-wrapper-top"></div>
        <Card className="our-client-say-card">
          <CardHeader
            className="our-client-say-card-header"
            avatar={<Avatar aria-label="recipe">P</Avatar>}
            title="Phani Puttabakula"
            subheader="Founder at, BlueFunda."
          />
          <CardContent className="our-client-say-card-content">
            <Typography>
              "Wizzgeeks has been a reliable partner over the past year,
              consistenly providing four skilled developers who deliver quality
              work. Their team is courteous, hardworking, and sincere in their
              efforts. Technical support is timely and effective, ensuring
              smooth day-to-day operations. The employees are honest,
              professional, and dedicated to their roles. Their contributions
              have added strong value to our projects. Overall, Wizzgeeks has
              shown exceptional performance and dependability."
            </Typography>
          </CardContent>
        </Card>
        <Card className="our-client-say-card">
          <CardHeader
            className="our-client-say-card-header"
            avatar={<Avatar aria-label="recipe">S</Avatar>}
            title="R. Siva"
            subheader="Chief Edtech Innovation Officer"
          />
          <CardContent className="our-client-say-card-content">
            <Typography>
              "Collaborating with Wizzgeeks Pvt Ltd for the complete development
              of the Medsy.ai platform has been an exceptional experience. Led
              by their dynamic CEO, Mr. Vignesh, the young and passionate team
              at Wizzgeeks brought remarkable energy, technical expertise, and a
              strong problem-solving mindset to the table. From understanding
              the core vision to translating complex educational workflows into
              scalable, AI-powered solutions, they managed every
              aspect—requirement gathering, design, development, testing, and
              deployment—with impressive clarity and commitment. "
            </Typography>
          </CardContent>
        </Card>
        <Card className="our-client-say-card">
          <CardHeader
            className="our-client-say-card-header"
            avatar={<Avatar aria-label="recipe">M</Avatar>}
            title="Muruganantham Punniyamoorthy"
            subheader="CTO - GUVI | HCL"
          />
          <CardContent className="our-client-say-card-content">
            <Typography>
              "Working with Wizzgeeks to develop our Zen Portal has been a
              game-changer. They delivered a robust, scalable, and beautifully
              designed online learning platform that’s now actively used by a
              rapidly growing student base every day. The team's deep technical
              expertise, clear communication, and proactive problem-solving
              stood out throughout the project. What truly impressed us was
              their ability to understand our vision and turn it into a
              seamless, high-performing platform."
            </Typography>
          </CardContent>
        </Card>
        <div className="oppacity-wrapper-bottom"></div>
      </div>

      {/* mobileResponsive */}
      <div className="our-client-say-card-wrapper mobile-view-our-client-say-card">
        <Slider {...settings}>
          <Card className="our-client-say-card">
            <CardHeader
              className="our-client-say-card-header"
              avatar={<Avatar aria-label="recipe">P</Avatar>}
              title="Phani Puttabakula"
              subheader="Founder at, BlueFunda."
            />
            <CardContent className="our-client-say-card-content">
              <Typography>
                "Wizzgeeks has been a reliable partner over the past year,
                consistenly providing four skilled developers who deliver
                quality work. Their team is courteous, hardworking, and sincere
                in their efforts. Technical support is timely and effective,
                ensuring smooth day-to-day operations. The employees are honest,
                professional, and dedicated to their roles. Their contributions
                have added strong value to our projects. Overall, Wizzgeeks has
                shown exceptional performance and dependability."
              </Typography>
            </CardContent>
          </Card>
          <Card className="our-client-say-card">
            <CardHeader
              className="our-client-say-card-header"
              avatar={<Avatar aria-label="recipe">S</Avatar>}
              title="R. Siva"
              subheader="Chief Edtech Innovation Officer"
            />
            <CardContent className="our-client-say-card-content">
              <Typography>
                "Collaborating with Wizzgeeks Pvt Ltd for the complete
                development of the Medsy.ai platform has been an exceptional
                experience. Led by their dynamic CEO, Mr. Vignesh, the young and
                passionate team at Wizzgeeks brought remarkable energy,
                technical expertise, and a strong problem-solving mindset to the
                table. From understanding the core vision to translating complex
                educational workflows into scalable, AI-powered solutions, they
                managed every aspect—requirement gathering, design, development,
                testing, and deployment—with impressive clarity and commitment.
                "
              </Typography>
            </CardContent>
          </Card>
          <Card className="our-client-say-card">
            <CardHeader
              className="our-client-say-card-header"
              avatar={<Avatar aria-label="recipe">M</Avatar>}
              title="Muruganantham Punniyamoorthy"
              subheader="CTO - GUVI | HCL"
            />
            <CardContent className="our-client-say-card-content">
              <Typography>
                "Working with Wizzgeeks to develop our Zen Portal has been a
                game-changer. They delivered a robust, scalable, and beautifully
                designed online learning platform that’s now actively used by a
                rapidly growing student base every day. The team's deep
                technical expertise, clear communication, and proactive
                problem-solving stood out throughout the project. What truly
                impressed us was their ability to understand our vision and turn
                it into a seamless, high-performing platform."
              </Typography>
            </CardContent>
          </Card>
        </Slider>
      </div>
    </div>
  );
};

export default OurClientSayComponent;
